export enum Salutation {
  FRAU = 'Frau',
  HERR = 'Herr',
  DIVERS = 'Divers',
  ABTEILUNG = 'Abteilung'
}
